
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTop from '../../components/feature/ScrollToTop';
import Button from '../../components/base/Button';
import AnimatedSection from '../../components/base/AnimatedSection';

export default function Services() {
  const services = [
    {
      icon: 'ri-video-line',
      title: 'تصوير وإنتاج الفيديو',
      description: 'إنتاج فيديوهات احترافية عالية الجودة لجميع المناسبات والأغراض التجارية والتسويقية',
      features: ['تصوير 4K و 8K', 'إضاءة احترافية', 'معدات حديثة', 'فريق متخصص'],
      price: 'يبدأ من 5,000 ريال',
      image: 'https://public.readdy.ai/ai/img_res/ba898619434ec2ae50636b6fa010a71a.jpg'
    },
    {
      icon: 'ri-movie-2-line',
      title: 'الموشن جرافيك والرسوم المتحركة',
      description: 'تصميم رسوم متحركة إبداعية ثنائية وثلاثية الأبعاد تجذب الانتباه وتوصل رسالتك بفعالية',
      features: ['رسوم ثنائية الأبعاد', 'رسوم ثلاثية الأبعاد', 'تأثيرات بصرية', 'شخصيات متحركة'],
      price: 'يبدأ من 3,000 ريال',
      image: 'https://readdy.ai/api/search-image?query=Motion%20graphics%20and%20animation%20studio%20workspace%20with%20multiple%20monitors%20displaying%203D%20animations%2C%20creative%20design%20software%2C%20and%20modern%20digital%20art%20creation%20environment&width=600&height=400&seq=12&orientation=landscape'
    },
    {
      icon: 'ri-mic-line',
      title: 'التسجيل الصوتي والدوبلاج',
      description: 'خدمات تسجيل صوتي احترافية في استوديوهات مجهزة بأحدث التقنيات الصوتية العالمية',
      features: ['استوديو عازل للصوت', 'معدات تسجيل متطورة', 'مهندسي صوت محترفين', 'خدمات الدوبلاج'],
      price: 'يبدأ من 1,500 ريال',
      image: 'https://readdy.ai/api/search-image?query=Professional%20audio%20recording%20studio%20with%20soundproof%20booth%2C%20mixing%20console%2C%20microphones%2C%20and%20audio%20engineering%20equipment%20in%20modern%20Saudi%20Arabian%20media%20facility&width=600&height=400&seq=13&orientation=landscape'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'المونتاج والإخراج',
      description: 'مونتاج احترافي وإخراج متقن يحول أفكارك إلى واقع مرئي مذهل باستخدام أحدث البرامج',
      features: ['مونتاج متقدم', 'تصحيح الألوان', 'المؤثرات البصرية', 'الإخراج النهائي'],
      price: 'يبدأ من 2,000 ريال',
      image: 'https://readdy.ai/api/search-image?query=Video%20editing%20suite%20with%20multiple%20high-resolution%20monitors%2C%20professional%20editing%20software%2C%20color%20grading%20equipment%2C%20and%20post-production%20workspace%20in%20modern%20media%20company&width=600&height=400&seq=14&orientation=landscape'
    },
    {
      icon: 'ri-camera-line',
      title: 'التصوير الفوتوغرافي',
      description: 'التقاط لحظات استثنائية بجودة عالية للمناسبات والمنتجات والبورتريه الشخصي والتجاري',
      features: ['تصوير المناسبات', 'تصوير المنتجات', 'البورتريه', 'التصوير التجاري'],
      price: 'يبدأ من 1,000 ريال',
      image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20studio%20with%20lighting%20setup%2C%20cameras%2C%20backdrop%2C%20and%20photographer%20capturing%20high-quality%20commercial%20and%20portrait%20photography%20in%20Saudi%20Arabian%20setting&width=600&height=400&seq=15&orientation=landscape'
    },
    {
      icon: 'ri-live-line',
      title: 'البث المباشر والتغطية الإعلامية',
      description: 'حلول البث المباشر المتطورة للفعاليات والمؤتمرات والأحداث الخاصة والعامة',
      features: ['بث مباشر عالي الجودة', 'تغطية شاملة', 'بث متعدد المنصات', 'فريق تقني متخصص'],
      price: 'يبدأ من 8,000 ريال',
      image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20and%20broadcast%20setup%20with%20multiple%20cameras%2C%20streaming%20equipment%2C%20control%20room%2C%20and%20technical%20crew%20covering%20events%20in%20professional%20Saudi%20Arabian%20media%20production&width=600&height=400&seq=16&orientation=landscape'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'التشاور والتخطيط',
      description: 'نبدأ بفهم احتياجاتكم ووضع خطة شاملة للمشروع',
      icon: 'ri-discuss-line'
    },
    {
      step: '02',
      title: 'التصميم والإعداد',
      description: 'نصمم المفهوم الإبداعي ونعد كل ما يلزم للتنفيذ',
      icon: 'ri-draft-line'
    },
    {
      step: '03',
      title: 'التنفيذ والإنتاج',
      description: 'ننفذ المشروع باحترافية عالية ونراقب كل التفاصيل',
      icon: 'ri-play-circle-line'
    },
    {
      step: '04',
      title: 'المراجعة والتسليم',
      description: 'نراجع العمل معكم ونسلمه في أفضل صورة ممكنة',
      icon: 'ri-check-double-line'
    }
  ];

  const packages = [
    {
      name: 'الباقة الأساسية',
      price: '15,000',
      duration: 'شهر واحد',
      features: [
        'فيديو ترويجي واحد (دقيقتان)',
        'تصوير في موقع واحد',
        'مونتاج أساسي',
        'موسيقى خلفية',
        'مراجعتان مجانيتان'
      ],
      popular: false
    },
    {
      name: 'الباقة المتقدمة',
      price: '35,000',
      duration: 'شهرين',
      features: [
        '3 فيديوهات ترويجية',
        'تصوير في 3 مواقع مختلفة',
        'موشن جرافيك متقدم',
        'تسجيل صوتي احترافي',
        'تصحيح ألوان متقدم',
        '5 مراجعات مجانية'
      ],
      popular: true
    },
    {
      name: 'الباقة الشاملة',
      price: '75,000',
      duration: '3 أشهر',
      features: [
        'حملة إعلامية متكاملة',
        'تصوير غير محدود',
        'فريق إنتاج كامل',
        'استراتيجية محتوى',
        'بث مباشر للفعاليات',
        'دعم مستمر لمدة 6 أشهر'
      ],
      popular: false
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative pt-20 pb-32 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://readdy.ai/api/search-image?query=Professional%20media%20services%20showcase%20with%20various%20production%20equipment%2C%20cameras%2C%20lighting%2C%20audio%20gear%2C%20and%20creative%20workspace%20representing%20comprehensive%20media%20production%20services%20in%20Saudi%20Arabia&width=1920&height=1080&seq=17&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <AnimatedSection animation="fadeIn">
            <h1 className="text-5xl md:text-7xl font-bold mb-6">خدماتنا المتميزة</h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
              نقدم مجموعة شاملة من الخدمات الإعلامية المتخصصة لتلبية جميع احتياجاتكم بأعلى معايير الجودة
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp" className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">خدماتنا الشاملة</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              نوفر حلولاً إبداعية متكاملة تغطي جميع جوانب الإنتاج الإعلامي
            </p>
          </AnimatedSection>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {services.map((service, index) => (
              <AnimatedSection 
                key={index} 
                animation="slideUp" 
                delay={index * 100}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden group"
              >
                <div className="md:flex">
                  <div className="md:w-1/2">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-64 md:h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="md:w-1/2 p-8">
                    <div className="w-16 h-16 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                      <i className={`${service.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
                    
                    <div className="mb-6">
                      <h4 className="font-semibold text-gray-900 mb-3">ما نقدمه:</h4>
                      <ul className="space-y-2">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center text-gray-600">
                            <div className="w-4 h-4 flex items-center justify-center mr-3">
                              <i className="ri-check-line text-green-500"></i>
                            </div>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="flex items-center justify-between">
                      <span className="text-2xl font-bold text-yellow-600">{service.price}</span>
                      <Button variant="primary" size="sm">
                        اطلب الخدمة
                      </Button>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp" className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">كيف نعمل</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              عملية منظمة ومدروسة لضمان تحقيق أفضل النتائج
            </p>
          </AnimatedSection>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {process.map((step, index) => (
              <AnimatedSection 
                key={index} 
                animation="slideUp" 
                delay={index * 150}
                className="text-center group"
              >
                <div className="relative mb-8">
                  <div className="w-20 h-20 bg-gradient-to-r from-yellow-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {step.step}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp" className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">باقاتنا المميزة</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              اختر الباقة التي تناسب احتياجاتك وميزانيتك
            </p>
          </AnimatedSection>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {packages.map((pkg, index) => (
              <AnimatedSection 
                key={index} 
                animation="slideUp" 
                delay={index * 100}
                className={`relative bg-gray-800 rounded-2xl p-8 ${pkg.popular ? 'ring-4 ring-yellow-500 transform scale-105' : ''} hover:bg-gray-700 transition-all duration-300`}
              >
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-yellow-500 text-black px-4 py-2 rounded-full text-sm font-bold">
                      الأكثر طلباً
                    </span>
                  </div>
                )}
                
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold mb-4">{pkg.name}</h3>
                  <div className="text-4xl font-bold text-yellow-500 mb-2">{pkg.price} ريال</div>
                  <div className="text-gray-400">{pkg.duration}</div>
                </div>
                
                <ul className="space-y-4 mb-8">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center">
                      <div className="w-5 h-5 flex items-center justify-center mr-3">
                        <i className="ri-check-line text-green-500"></i>
                      </div>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <Button 
                  variant={pkg.popular ? "primary" : "outline"} 
                  size="lg" 
                  className="w-full"
                >
                  اختر هذه الباقة
                </Button>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-yellow-600 to-red-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <AnimatedSection animation="fadeIn">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">مستعد لبدء مشروعك؟</h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
              تواصل معنا اليوم واحصل على استشارة مجانية وعرض سعر مخصص لمشروعك
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="outline" size="lg" href="/contact" className="bg-white text-gray-900 hover:bg-gray-100">
                احصل على استشارة مجانية
              </Button>
              <Button variant="secondary" size="lg" href="/portfolio">
                شاهد أعمالنا السابقة
              </Button>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
}
